import { j as p } from "./jsx-runtime-3tyXYecC.mjs";
import j, { forwardRef as K, useEffect as T, useState as W, useRef as Q, useMemo as H, useCallback as f, Fragment as R, cloneElement as V } from "react";
import { d as X } from "./index-DH8DM7A9.mjs";
import { f as i } from "./index-LyFokDcn.mjs";
import { g as Y } from "./index-lgh2EImO.mjs";
import { l as v } from "./lodash-5ofSKtz3.mjs";
import { m as D, b as ee } from "./tss-DN0acMKN.mjs";
import { M as te, d as re } from "./constants-CnFYFetN.mjs";
import { P as oe } from "./Popper-X3MMNHL3.mjs";
import { F as ie } from "./Fade-B7C8Y6jW.mjs";
const ne = D({ name: "Tooltip" })(({ constructs: c, mode: r, palette: t, typography: l, spacing: F }, { zIndex: L }, s) => {
  const n = "0.71em";
  return {
    root: {
      pointerEvents: "none",
      zIndex: L,
      [`&[data-popper-placement*="bottom"] .${s.arrow}`]: {
        top: 0,
        left: 0,
        marginTop: `-${n}`,
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${s.arrow}`]: {
        bottom: 0,
        left: 0,
        marginBottom: `-${n}`,
        "&:before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${s.arrow}`]: {
        left: 0,
        marginLeft: `-${n}`,
        height: "1em",
        width: n,
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${s.arrow}`]: {
        right: 0,
        marginRight: `-${n}`,
        height: "1em",
        width: n,
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    },
    popperInteractive: {
      pointerEvents: "auto"
    },
    tooltip: {
      backgroundColor: i.ifFeature("encore", t.grey[900], t.grey[800]),
      borderRadius: i.ifFeature("encore", "8px", "2px"),
      boxShadow: i.ifFeature(
        "encore",
        `4px 4px 6x 2px ${ee(c.surface.neutral.xxStrong, 0.12)}`,
        "0 1px 3px rgba(0,0,0,0.20)"
      ),
      color: t.common.white,
      fontSize: "0.866rem",
      // 13px: typography.bodyTeenie
      fontWeight: l.fontWeightMedium,
      lineHeight: "1.2rem",
      // 18px: typography.bodyTeenie
      maxWidth: "263px",
      outline: r === te.Dye ? `2px solid ${re.main}` : void 0,
      position: "relative"
    },
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: {
      transformOrigin: "right center",
      margin: i.ifFeature("encore", "0 8px", "0 11px")
    },
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: {
      transformOrigin: "left center",
      margin: i.ifFeature("encore", "0 8px", "0 11px")
    },
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: {
      transformOrigin: "center bottom",
      margin: i.ifFeature("encore", "8px 0", "11px 0")
    },
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: {
      transformOrigin: "center top",
      margin: i.ifFeature("encore", "8px 0", "11px 0")
    },
    content: {
      backgroundColor: "inherit",
      borderRadius: "inherit",
      padding: i.ifFeature("encore", F(1.5), "11px 15px"),
      position: "relative",
      textAlign: "center",
      zIndex: 1
    },
    arrow: {
      filter: "drop-shadow(0 3px 2px rgba(0,0,0,0.20))",
      boxSizing: "border-box",
      color: t.grey[800],
      height: n,
      overflow: "hidden",
      position: "absolute",
      fontSize: "13px",
      width: "1em",
      zIndex: 0,
      "&::before": {
        content: '""',
        margin: "auto",
        display: "block",
        width: "100%",
        height: "100%",
        backgroundColor: "currentColor",
        transform: "rotate(45deg)"
      }
    },
    title: {
      display: "block",
      fontSize: i.ifFeature("encore", l.large.fontSize, l.body2.fontSize),
      fontWeight: l.fontWeightBold,
      lineHeight: i.ifFeature("encore", "24px", "1.133rem"),
      // 17px
      marginBottom: 2
    }
  };
}), se = 200, be = K(
  ({
    anchorEl: c,
    anchorRef: r,
    children: t,
    className: l,
    classes: F = {},
    content: L,
    enterDelay: s = 0,
    id: n,
    open: S,
    leaveDelay: d = 0,
    onClose: I,
    onOpen: O,
    placement: N = "top",
    title: A
  }, Z) => {
    if (T(() => {
      t && console.warn(
        "The `children` prop is deprecated and will be removed in future versions. Please use the `anchorRef` prop instead."
      );
    }, [t]), t && v.isArray(t))
      return console.error("Invalid prop `children` of type `array` supplied to Tooltip. Expected a single ReactElement."), t;
    const x = v.isBoolean(S), [$, y] = W(void 0), C = Q(0), _ = H(() => {
      if ($) {
        const e = X.getMaxZIndex() + 10;
        return C.current = e, e;
      }
      return C.current;
    }, [$]), [q, U] = W(null), g = t ? { ...t.props } : {}, G = j.useRef(), o = g.ref || G;
    g && (g.ref = o);
    const k = j.useRef(), b = j.useRef(), E = () => {
      k.current && clearTimeout(k.current), b.current && clearTimeout(b.current);
    }, M = f(
      (e) => {
        y(!0), O && O(e);
      },
      [O]
    ), h = f(
      (e) => {
        y(!1), I && I(e);
      },
      [I]
    ), a = f(
      (e) => {
        e != null && e.persist && e.persist(), E(), k.current = setTimeout(() => {
          M(e);
        }, s);
      },
      [s, M]
    ), m = f(
      (e) => {
        e != null && e.persist && e.persist(), E(), b.current = setTimeout(() => {
          h(e);
        }, d);
      },
      [h, d]
    ), z = f(
      (e) => {
        (e == null ? void 0 : e.key) === "Escape" && (E(), b.current = setTimeout(() => {
          h(e);
        }, d));
      },
      [h, d]
    );
    T(() => () => {
      E();
    }, []), T(() => {
      const e = (r == null ? void 0 : r.current) || (o == null ? void 0 : o.current) || Y(c);
      return e && !(e instanceof Element) ? console.error("Invalid `anchorEl` or `children` prop supplied to Tooltip. Must be a ReactElement.") : e && !x && (e.addEventListener("mouseenter", a), e.addEventListener("focusin", a), e.addEventListener("mouseleave", m), e.addEventListener("focusout", m), e.addEventListener("keydown", z)), () => {
        e instanceof Element && e.removeEventListener && (e.removeEventListener("mouseenter", a), e.removeEventListener("focusin", a), e.removeEventListener("mouseleave", m), e.removeEventListener("focusout", m), e.removeEventListener("keydown", z));
      };
    }, [c, r, o, x, a, m, z]), T(() => {
      x && (S ? a() : m());
    }, [S, x, a, m]);
    const { classes: u, cx: B } = ne({ zIndex: _ }, { props: { classes: F } }), P = H(() => n || v.uniqueId("tooltip-"), [n]), w = (r == null ? void 0 : r.current) || (o == null ? void 0 : o.current) || c;
    return w && "setAttribute" in w && w.setAttribute("aria-describedby", P), /* @__PURE__ */ p.jsxs(R, { children: [
      t && V(t, g),
      ((r == null ? void 0 : r.current) || (o == null ? void 0 : o.current) || c) && /* @__PURE__ */ p.jsx(
        oe,
        {
          anchorEl: w,
          className: B(l, u.root),
          "data-fabric-component": "Tooltip",
          id: P,
          modifiers: [
            {
              name: "arrow",
              enabled: !0,
              options: {
                element: q
              }
            }
          ],
          open: !!$,
          placement: N,
          role: "tooltip",
          transition: !0,
          children: ({ placement: e, TransitionProps: J }) => /* @__PURE__ */ p.jsx(ie, { ...J, timeout: se, children: /* @__PURE__ */ p.jsxs(
            "div",
            {
              className: B(u.tooltip, u[`tooltipPlacement${v.capitalize(e.split("-")[0])}`]),
              ref: Z,
              children: [
                /* @__PURE__ */ p.jsxs("div", { className: u.content, children: [
                  A && /* @__PURE__ */ p.jsx("span", { className: u.title, children: A }),
                  L
                ] }),
                i.ifFeature(
                  "encore",
                  void 0,
                  /* @__PURE__ */ p.jsx("span", { className: u.arrow, ref: U })
                )
              ]
            }
          ) })
        }
      )
    ] });
  }
);
export {
  be as T
};
//# sourceMappingURL=tooltip-Cy1xtUCm.mjs.map
